import useApplication from "./useApplication";

const useModule = (moduleName) => {

    const { application } = useApplication();

    return application.module(moduleName);
}

export default useModule;